import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 7v2a1 1 0 01-1 1h-2c-.55 0-1-.45-1-1V7a1 1 0 011-1h2a1 1 0 011 1zM5 10c-.55 0-1-.45-1-1V7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H5zm10 6H5c0-7 10-7 10 0zm3-12.397v5.982C18 13.996 14.411 18 10 18s-8-4.004-8-8.415v-7C2 2.033 2.448 2 3 2h14c.552 0 1 .033 1 .585v1.018zM18 0H2C.895 0 0 .48 0 1.585v8c0 2.246.75 4.312 2 5.982a10.075 10.075 0 002.018 2.018C5.688 18.835 7.754 20 10 20s4.312-1.165 5.982-2.415A10.101 10.101 0 0018 15.567c1.25-1.67 2-3.736 2-5.982v-8C20 .48 19.105 0 18 0z",
  fillRule: "evenodd"
});

var EmojiSad32Icon = function EmojiSad32Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
EmojiSad32Icon.defaultProps = {
  size: 1.5
};
export default EmojiSad32Icon;